import React, { useState, useEffect } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { EE, HelperCore } from '@/common/dependencies';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import globalStore from '@/store/global';
import client from '@/store/client';
import { useRef } from 'react';
import membershipStore from '@/components/membership/store';
import userStore from '@/store/user';

const DEFALUT_IFRAME_PARAMS = {
  style : {
    width : "100%",
    height : "100%",
    flexShrink: 0,
  }
}

const isSafeUrl = str => {
  try {
    const url = new URL(str);
    if(/(360\.cn|360\.com|n\.cn)$/.test(url.host)){
      return true;
    }
  } catch (error) {
    return false;
  }
};

const ToolsPage = observer((props) => {
  const { loaded, type = 'index', className = '' } = props;
  const iframeRef = useRef()
  
  const config = useMemo(() => {
    const config = HelperCore.copyObj((globalStore.cloudConfig.assistantLeftSideTools || []).find(item => item.type == type));
    if(config){
      if(config.iframe_params){
        try{
          config.iframe_params = JSON.parse(config.iframe_params);
        } catch(e){
          config.iframe_params = DEFALUT_IFRAME_PARAMS;
        }
      }
      else {
        config.iframe_params = DEFALUT_IFRAME_PARAMS;
      }

      // toB 客户端，定制网页地址
      if(config.type == "webpage" && client.isToB){
        config.url = "chrome-extension://milhmifoljmifighlanebdlekdjhbibd/index.html";
      }
      // 回归环境，定制知识库之地
      if(config.type == "knowledge" && ["online", "devonline"].includes(import.meta.env.MODE)){
        config.url = config.url.replace("https://nami-ai-browser.safe.360.cn", "https://pre-nami-ai-browser.safe.360.cn");
      }
    }
    return config;
  }, [type, client.isToB, globalStore.cloudConfigReady]);

  useEffect(() => {
    function handleMyknowledgeChange() {
      iframeRef?.current?.contentWindow?.postMessage({ 
        action: 'loadMyKnowledge', 
        data: '',
      }, '*');
    }
    if(config?.type == "knowledge") {
      EE.on('MyknowledgeChange',handleMyknowledgeChange)
    }
    return () => {
      if(config?.type == "knowledge") {
        EE.off('',handleMyknowledgeChange)
      }
    }
  }, [config])

  const getOrigin = () => {
    const url = new URL(iframeRef?.current?.src || '');
    return url.origin || '';
  }

  const handleMessage = async (e) => {
    var action = e.data.action
    // console.log("e", e);
    if (!iframeRef?.current?.src?.includes?.(e.origin)) {
      return
    }

    switch (action) {
      case 'openCashierDesk':
        const cashierType = e.data.data?.params?.cashier_type || '';
        const function_id = e.data.data?.params?.function_id || '';
        membershipStore.setData({
          show: true,
          checkstandType: cashierType,
          position: function_id || ""
        })
        break;
      case 'login':
        userStore.gotoLogin(() => {
          console.log("logined");
          e.source.postMessage({
            type: "namiAI",
            action: "loginCb",
            data: {}
          }, e.origin);
        },"", false, () => {
          client.SyncLoginCookie(e.origin).then(res => {
            if(res == 1) {
              console.log("logined");
              e.source.postMessage({
                type: "namiAI",
                action: "loginCb",
                data: {}
              }, e.origin);
            }
          })
        });
        break;
    }
  }

  const onPaysuccess = () => {
    iframeRef?.current?.contentWindow?.postMessage({
      type: "namiAI",
      action: "aiPaySuccess",
      data: {}
    }, "*")
  }

  const onLoginStatusUpdate = ({logined}) => {
    console.log("loginCb");
    iframeRef?.current?.contentWindow?.postMessage({
      type: "namiAI",
      action: "loginCb",
      data: {}
    }, "*")
  }

  useEffect(() => {
    EE.on('membership:paysuccess', onPaysuccess);
    EE.on("toolsLoginStatusUpdate", onLoginStatusUpdate);
    window.addEventListener('message', handleMessage);
    return () => {
      EE.removeListener('membership:paysuccess', onPaysuccess)
      EE.removeListener('toolsLoginStatusUpdate', onLoginStatusUpdate)
      window.removeEventListener('message', handleMessage);
    };
  }, [])

  //知识库模块是通过 iframe 嵌入在纳米的知识库模块中的，由于知识库模块会有落地页的情况，落地页需要在端内打开知识库页面，
  //为了保证打开正确的知识库页面，现约定如下：
  //纳米前端地址?kb-link=知识库链接，知识库链接默认为 namiDomain/knowledge-base/personal-space
  const urlParams = HelperCore.getParams() || {};
  const isKnowledge = type == 'knowledge';
  const kbLink = decodeURIComponent(urlParams['kb-link']|| '');
  
  if(!loaded) return null;
  if(!config) return null;

  return (
    <div className={['w-0 flex-grow h-full', className]}>
      <div className="size-full flex">
        {
          !config
          ? null 
          : (
            <iframe
              ref={iframeRef}
              allow="camera *;microphone *;clipboard-write"
              src={HelperCore.repaireUrl(isKnowledge && kbLink && isSafeUrl(kbLink) ? kbLink : config.url)}
              {...config.iframe_params}
              />
          )
        }
      </div>
    </div>
  )
});
export default ToolsPage;